import { render, staticRenderFns } from "./exhibition-login.vue?vue&type=template&id=bcd4e8bc&scoped=true&"
import script from "./exhibition-login.vue?vue&type=script&lang=js&"
export * from "./exhibition-login.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-login.vue?vue&type=style&index=0&id=bcd4e8bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd4e8bc",
  null
  
)

export default component.exports